<template>
  <div class="primary-tabs-shell">
    <div
      class="primary-tabs"
      :class="{ 'is-compact': tabsList.length >= 5 }"
      :style="{ gridTemplateColumns: 'repeat(' + tabsList.length + ', 1fr)' }"
    >
      <component
        :is="item.path ? 'router-link' : 'button'"
        v-for="item in tabsList"
        :key="item.value"
        :to="item.path"
        :type="item.path ? null : 'button'"
        class="primary-item"
        :class="{ 'item-active': activeValue == item.value }"
        @click="handleClickItem(item)"
      >
        <span v-if="item.icon" class="primary-icon">
          <operation-icon :name="item.icon"></operation-icon>
        </span>
        <span class="primary-copy">
          <strong>{{ item.label }}</strong>
          <small v-if="item.subtitle">{{ item.subtitle }}</small>
        </span>
      </component>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import OperationIcon from "../zhiHuiYunWei/cpns/operation-icon.vue";

export default {
  name: "PrimaryTabs",
  components: { OperationIcon },
  props: {
    tabsList: {
      type: Array,
      default: () => [],
    },
    activeValue: {
      type: [String, Number],
      default: "",
    },
  },
  methods: {
    handleClickItem(item) {
      this.$emit("tab-change", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.primary-tabs-shell {
  width: calc(100% - 120px);
  max-width: 1700px;
  margin: -78px auto 54px;
  position: relative;
  z-index: 10;
}

.primary-tabs {
  min-height: 112px;
  display: grid;
  overflow: visible;
  border: 1px solid #e4ebf5;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 16px 42px rgba(18, 68, 145, 0.14);
}

.primary-item {
  min-width: 0;
  min-height: 112px;
  padding: 0 46px;
  display: flex;
  align-items: center;
  gap: 22px;
  position: relative;
  color: #1d1d1d;
  border: 0;
  border-right: 1px solid #e5eaf2;
  background: transparent;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s, background 0.2s;

  &:first-child {
    border-radius: 9px 0 0 9px;
  }

  &:last-child {
    border-right: 0;
    border-radius: 0 9px 9px 0;
  }

  &.item-active {
    color: #fff;
    background: linear-gradient(135deg, #1f63ea, #5c91ff);

    &::after {
      content: "";
      width: 18px;
      height: 18px;
      position: absolute;
      left: 50%;
      bottom: -9px;
      background: #568cfb;
      transform: translateX(-50%) rotate(45deg);
    }

    .primary-icon {
      color: #fff;
      border-color: rgba(255, 255, 255, 0.72);
      background: rgba(255, 255, 255, 0.12);
    }

    .primary-copy small {
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.primary-icon {
  width: 58px;
  height: 58px;
  flex: none;
  display: grid;
  place-items: center;
  box-sizing: border-box;
  padding: 12px;
  color: #1f63ea;
  border: 2px solid #b8d3ff;
  border-radius: 14px;
  background: #f2f7ff;
}

.primary-copy {
  min-width: 0;
  text-align: left;

  strong,
  small {
    display: block;
  }

  strong {
    margin-bottom: 9px;
    font-size: 23px;
    font-weight: 500;
  }

  small {
    overflow: hidden;
    color: #7d8797;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.is-compact {
  .primary-item {
    padding: 0 22px;
    gap: 15px;
  }

  .primary-icon {
    width: 48px;
    height: 48px;
    padding: 10px;
    border-radius: 12px;
  }

  .primary-copy strong {
    margin-bottom: 7px;
    font-size: 19px;
    white-space: nowrap;
  }

  .primary-copy small {
    font-size: 12px;
  }
}

@media (max-width: 1440px) {
  .is-compact {
    .primary-item {
      padding: 0 16px;
      gap: 12px;
    }

    .primary-icon {
      width: 42px;
      height: 42px;
      padding: 9px;
    }

    .primary-copy strong {
      font-size: 17px;
    }
  }
}

@media (max-width: 900px) {
  .primary-tabs-shell {
    width: calc(100% - 32px);
    margin-top: -42px;
    overflow-x: auto;
  }

  .primary-tabs {
    min-width: 780px;
  }

  .primary-tabs.is-compact {
    min-width: 1120px;
  }

  .primary-item {
    padding: 0 28px;
  }

  .is-compact .primary-item {
    padding: 0 18px;
  }
}
</style>
